import { takeLatest } from 'redux-saga/effects';
import { JOIN_FAIR_PLAY_INIT } from '../../actions/fairPlay';
import { joinFairPlay } from './joinFairPlay';

export function* fairPlaySagas() {
  yield takeLatest([JOIN_FAIR_PLAY_INIT], joinFairPlay);
}
